export default __webpack_public_path__ + "static/media/facebook.07e2155c.png";